import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* createAssignment({ payload: { values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.assignments.create, data: values });

    onSuccess && onSuccess();
    yield put(actions.createAssignmentDone(data.result));
  } catch (error) {
    onError && onError();
    yield handleErrors({
      error,
      putErrorData: actions.createAssignmentFailed,
      handledErrors,
      endpoint: api.modifiers.assignments.create.url
    });
  }
}

export const createAssignmentSaga = takeEvery(types.CREATE_ASSIGNMENT_REQUEST, createAssignment);